import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { formatDateTimeWithLiveStatus } from '../utils/timeFormatter';
import { getStreamStatus } from '../utils/statusCalculator';
import '../styles/StreamModal.css';

const StreamModal = ({ stream, isOpen, onClose }) => {
  // ESCキーでモーダルを閉じる
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'hidden'; // スクロールを無効化
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset'; // スクロールを復元
    };
  }, [isOpen, onClose]);

  // モーダルが閉じている場合は何も表示しない
  if (!isOpen || !stream) return null;



  // 背景クリックでモーダルを閉じる
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // ストリームのステータスを取得
  const status = getStreamStatus(stream);
  const isLive = status === 'live';

  // 視聴ボタンのクリック
  const handleWatchClick = () => {
    if (stream.url && stream.url !== '#') {
      window.open(stream.url, '_blank');
    }
  };

  // プラットフォームに応じたボタンテキストとアイコンの取得
  const getWatchButtonText = () => {
    if (stream.platform === 'ツイキャス') {
      return 'ツイキャスで視聴';
    }
    if (stream.platform === 'Twitch') {
      return 'Twitchで視聴';
    }
    return 'YouTubeで視聴';
  };

  const getWatchButtonIcon = () => {
    return '▶';
  };

  const getWatchButtonClass = () => {
    if (stream.platform === 'ツイキャス') {
      return 'watch-button twitcasting';
    }
    if (stream.platform === 'Twitch') {
      return 'watch-button twitch';
    }
    return 'watch-button';
  };

  return ReactDOM.createPortal(
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        {/* 閉じるボタン（stickyで右上に固定） */}
        <div className="modal-actions">
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        {/* ヘッダー */}
        <div className="modal-header">
          <div className="modal-datetime">
            {formatDateTimeWithLiveStatus(stream.startTime, isLive)}
          </div>
        </div>

        {/* メイン画像 */}
        <div className="modal-image" onClick={handleWatchClick} style={{cursor: 'pointer'}}>
          <img src={stream.thumbnailUrl} alt={stream.title} draggable={true} />
        </div>

        {/* 配信情報 */}
        <div className="modal-info">
          <div className="modal-title-overlay">
            <h2>{stream.title}</h2>
          </div>
          <div className="streamer-info">
            {stream.channelUrl ? (
              <a 
                href={stream.channelUrl} 
                target="_blank" 
                rel="noopener" 
                className="streamer-header"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {stream.channelThumbnails?.url && (
                  <div className="streamer-avatar">
                    <img src={stream.channelThumbnails.url} alt={stream.streamer} draggable={true} />
                  </div>
                )}
                <h3 className="streamer-name">{stream.streamer}</h3>
              </a>
            ) : (
              <div className="streamer-header">
                {stream.channelThumbnails?.url && (
                  <div className="streamer-avatar">
                    <img src={stream.channelThumbnails.url} alt={stream.streamer} draggable={true} />
                  </div>
                )}
                <h3 className="streamer-name">{stream.streamer}</h3>
              </div>
            )}
            <div className="stream-description">
              {stream.description && stream.description
                .replace(/\\n/g, '\n')  // エスケープされた\nを実際の改行に変換
                .split('\n')
                .map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
            </div>
          </div>
        </div>
      </div>

      {/* 固定ボタンエリア */}
      <div className="modal-button-area">
        <button className={getWatchButtonClass()} onClick={handleWatchClick}>
          <span className="platform-icon">{getWatchButtonIcon()}</span>
          {getWatchButtonText()}
        </button>
      </div>

    </div>,
    document.body
  );
};

export default StreamModal;
